import {
  CheckOutlined,
  QuestionCircleOutlined,
  TranslationOutlined,
} from '@ant-design/icons';
import {
  AvatarDropdown as CoreAvatarDropdown,
  type CoreUserMenuItem,
  useLocale,
  useShell,
} from '@zhiyue/core';
import { BizAppConfig } from 'config/application.manifest';
import React from 'react';

const AvatarDropdown: React.FC = () => {
  const { locale, setLocale } = useLocale();
  const { shellConfig } = useShell();

  const menuItems = React.useMemo<CoreUserMenuItem[]>(() => {
    const items: CoreUserMenuItem[] = [];
    const helpUrl = shellConfig.ui.links.help;

    if (helpUrl) {
      items.push({
        key: 'help',
        label: '帮助与文档',
        icon: <QuestionCircleOutlined />,
        href: helpUrl,
        target: '_blank',
      });
      items.push({ type: 'divider' });
    }

    items.push({
      key: 'language-heading',
      label: '语言',
      icon: <TranslationOutlined />,
      disabled: true,
    });

    for (const option of shellConfig.ui.locales) {
      items.push({
        key: `locale:${option.key}`,
        label: (
          <span className="app-user-menu-locale">
            <span aria-hidden="true">{option.icon || '🌐'}</span>
            <span>{option.label}</span>
            <CheckOutlined
              className="app-user-menu-locale-check"
              aria-hidden={option.key !== locale}
              style={{
                visibility: option.key === locale ? 'visible' : 'hidden',
              }}
            />
          </span>
        ),
      });
    }

    return items;
  }, [locale, shellConfig.ui.links.help, shellConfig.ui.locales]);

  return (
    <CoreAvatarDropdown
      appId={BizAppConfig.appSsoClientId}
      workbenchUrl={BizAppConfig.appWorkbenchUrl}
      tenantManagementUrl={BizAppConfig.appTenantManagementUrl}
      personalCenterUrl={BizAppConfig.appPersonalCenterUrl}
      items={menuItems}
      mergeDefaultItems
      onAction={(key) => {
        if (key.startsWith('locale:')) {
          setLocale(key.slice('locale:'.length));
        }
      }}
    />
  );
};

export default AvatarDropdown;
